// extracted by mini-css-extract-plugin
export default {"addPurchasePanel":"index_addPurchasePanel__U0Nf-","imageMask":"index_imageMask__sDZKE"};